import React, { useState, useEffect, useMemo, useRef } from 'react';
import { API_BASE_URL } from '../config/apiConfig';
import './Services.css';

const Services = () => {
  const [services, setServices] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const startX = useRef(0);
  const deltaX = useRef(0);


  const serviceItems = useMemo(() => {
    const urlBase = API_BASE_URL.replace('/api', '');

    return services.map((service) => {
      const mediaList = [];
      if (service.path_image) {
        mediaList.push({
          id: service.id,
          type: 'image',
          src: `${urlBase}/storage/${service.path_image}`,
          title: service.title,
          description: service.description,
        });
      }

      return {
        id: service.id,
        title: service.title,
        description: service.description,
        mediaList,
      };
    }).filter(item => item.mediaList.length > 0);
  }, [services]);

  /* ===== SWIPE ===== */
  const handleStart = (e) => {
    setIsDragging(true);
    startX.current = e.touches ? e.touches[0].clientX : e.clientX;
  };

  const handleMove = (e) => {
    if (!isDragging) return;
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    deltaX.current = x - startX.current;
  };

  const handleEnd = () => {
    if (!isDragging || !selectedItem) return;

    const threshold = 70;
    const total = selectedItem.mediaList.length;

    if (deltaX.current < -threshold) {
      setCurrentIndex(i => Math.min(i + 1, total - 1));
    } else if (deltaX.current > threshold) {
      setCurrentIndex(i => Math.max(i - 1, 0));
    }

    deltaX.current = 0;
    setIsDragging(false);
  };

  useEffect(() => {
    const esc = (e) => e.key === 'Escape' && setSelectedItem(null);
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, []);

  return (
    <>
      <section id="servicios" className="services">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Nuestros Servicios</h2>
            <p className="section-subtitle">
              En Blink Informática ayudamos a personas, negocios y empresas a optimizar su tecnología con soluciones modernas, seguras y eficientes.
              Brindamos soporte técnico, desarrollo de software y creación de sitios web adaptados a cada necesidad.
            </p>
          </div>

              <div className="services-grid">
              
                  <div className="service-card service-bg">
                  <div className="bg-overlay" />
                    <h3 className="service-title">Soporte Informático</h3>
                    <p className="service-description">Mantenimiento, diagnóstico y solución de problemas para equipos y sistemas.</p>
                    <ul className="service-list">
                      <li>Reparación y optimización de PC</li>
                      <li>Instalación y configuración de software</li>
                      <li>Eliminación de virus y malware</li>
                      <li>Configuración de redes y Wi-Fi</li>
                      <li>Soporte remoto y presencial</li>
                      <li>Backup y recuperación de datos</li>
                      <li>Mantenimiento preventivo</li>
                    </ul>
                  </div>     

                  <div className="service-card service-bg">
                  <div className="bg-overlay" />
                    <h3 className="service-title">Desarrollo de Software</h3>
                    <p className="service-description">Creamos soluciones digitales a medida para automatizar procesos y mejorar la productividad.</p>
                    <ul className="service-list">
                      <li>Sistemas administrativos</li>
                      <li>Aplicaciones web empresariales</li>
                      <li>APIs y servicios REST</li>
                      <li>Integración con bases de datos</li>
                      <li>Automatización de procesos</li>
                      <li>Paneles de gestión y reportes</li>
                      <li>Desarrollo escalable y seguro</li>
                    </ul>
                  </div>                                                
            </div>          
        </div>
      </section>

      {/* MODAL (MISMA LOGICA QUE GALLERY) */}
      {selectedItem && (
        <div className="gallery-modal" onClick={() => setSelectedItem(null)}>
          <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>

            <button
              className="gallery-modal-close"
              onClick={() => setSelectedItem(null)}
            >
              ×
            </button>

            <h2>{selectedItem.title}</h2>
            <p className="modal-description">
              {selectedItem.description}
            </p>

            <div
              className="modal-swipe"
              onTouchStart={handleStart}
              onTouchMove={handleMove}
              onTouchEnd={handleEnd}
              onMouseDown={handleStart}
              onMouseMove={handleMove}
              onMouseUp={handleEnd}
              onMouseLeave={handleEnd}
            >
              {selectedItem.mediaList[currentIndex].type === 'image' ? (
                <img
                  src={selectedItem.mediaList[currentIndex].src}
                  draggable={false}
                  alt=""
                />
              ) : (
                <video
                  src={selectedItem.mediaList[currentIndex].src}
                  controls
                  muted
                  autoPlay
                  playsInline
                />
              )}
            </div>

            {/* ===== DOTS ===== */}
            {selectedItem.mediaList.length > 1 && (
              <div className="modal-dots">
                {selectedItem.mediaList.map((_, i) => (
                  <span
                    key={i}
                    className={`dot ${i === currentIndex ? 'active' : ''}`}
                    onClick={() => setCurrentIndex(i)}
                  />
                ))}
              </div>
            )}

          </div>
        </div>
      )}
    </>
  );
};

export default Services;

